import {willUseSharedCallback} from '@startlibs/core'


export const [useUpdateParams,callUpdateParams] = willUseSharedCallback()